import * as React from "react";
import "./Component468.css";
const Component468 = (props: { high: string, className?: string }) => {
  return (
    <div className={`component-468 ${props.className || ""}`}>
      {props.high || "High"}
    </div>
  );
};
export default Component468;
